import { configuration } from '@App/configs/index'
import { datadogRum } from '@datadog/browser-rum'
import pkg from '../../package.json'

export const isDatadogInitialized = () => Boolean(datadogRum.getInitConfiguration())

export const configureDatadog = () => {
    if (isDatadogInitialized()) {
        return
    }

    const isQA = configuration.env === 'qa' || configuration.env === 'dev'

    datadogRum.init({
        applicationId: configuration.datadog_app_id ?? '',
        clientToken: configuration.datadog_client_token ?? '',
        site: 'datadoghq.com',
        service: 'mlc-portal',
        env: configuration.env ?? 'local',
        version: isQA ? process.env.RELEASE_VERSION : pkg.version,
        startSessionReplayRecordingManually: true,
        allowedTracingUrls: [configuration.api, configuration.api2v],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100, // if not included, the default is 100
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        trackingConsent: 'granted',
        defaultPrivacyLevel: isQA ? 'allow' : 'mask',
    })

    if (isQA) {
        datadogRum.startSessionReplayRecording()
    }
}

export const setDatadogTrackingConsent = (hasStatisticsConsent: boolean) => {
    datadogRum.setTrackingConsent(hasStatisticsConsent ? 'granted' : 'not-granted')
}
